<nz-row>
  <nz-col nzSpan="24">
    <nz-list *ngIf="rolles.result$ | async" nzSize="large" [nzLoading]="$loading | async">
      <nz-list-item *ngFor="let rolle of (rolles.result$ | async).rolles" (click)="select.emit(rolle)">
        <nz-list-item-meta [nzDescription]="ListDescription">
          <ng-template #ListDescription>
            <!--- << description    -->
            <!---    description >> -->
          </ng-template>
          <nz-list-item-meta-title>
            <a>
              <!--- << content    -->
              {{ rolle.name }}
              <i *ngIf="rolle.isAdmin" nz-icon nzType="unlock" nzTheme="outline"></i>
              <i *ngIf="rolle.finanzen" nz-icon nzType="euro" nzTheme="outline"></i>
              <span nz-typography nzType="secondary"> {{ rolle.authorizedRoutes.length }} Freigaben </span>
              <!---    content >> -->
            </a>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <ul nz-list-item-actions>
          <nz-list-item-action>
            <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
          </nz-list-item-action>
        </ul>
      </nz-list-item>
    </nz-list>
  </nz-col>
</nz-row>
